import React from "react";
import AddPeopleController from "./AddPeopleController";

function OrganizationItem() {
  return <AddPeopleController isRoot />;
}

export default OrganizationItem;
